import axios from 'axios'
import env from '@/enviroment';
import lStorage from '@/store/localStorage';
import store from '@/store';
import {rest} from '@/utils/utils';

const trialBookingFlow = {
    namespaced: true,
    state: {
        currentStep: '',
        lesson: {},
        tech: {},
        trial: {},
    },
    mutations: {
        currentStep: (state, is) => {
            state.currentStep = is;
        },
        lesson: (state, lesson) => {
            state.lesson = lesson;
        },
        tech: (state, tech) => {
            state.tech = tech;
        },
        trial: (state, trial) => {
            state.trial = trial;
        },
    },
    getters: {
        currentStep: state => {
            return state.currentStep
        },
        lesson: state => {
            return state.lesson
        },
        tech: state => {
            return state.tech
        },
        trial: state => {
            return state.trial
        },
    },
    actions: {
        getHomeInfo(context) {
            store.commit('loading/is', true);
            rest.call("lead_status",{},"POST").then((response)=>{
                store.commit('loading/is',false);
                if(response.status == "ok" && response.data){
                    context.commit('currentStep',response.data.type);
                    context.commit('lesson',response.data.lesson);
                    context.commit('tech',response.data.tech);
                    context.commit('trial',response.data.trial);
                }
            }).catch((error)=>{
                store.commit('loading/is',false);
            });
        }
    }
};

export default trialBookingFlow;
